import i18n from '@/i18n'

export const menuMap = [
  {
    name: 'SIGURAN_NET',
    title: i18n.tc('digitalServices.sidebar.items.siguranNet')
  },
  {
    name: 'NBA',
    title: i18n.tc('digitalServices.sidebar.items.nba'),
    submenu: [
      {
        name: 'nba_instructions',
        title: i18n.tc('digitalServices.sidebar.items.instructions')
      }
    ]
  },
  {
    name: 'HBO',
    title: i18n.tc('digitalServices.sidebar.items.hbo'),
    submenu: [
      {
        name: 'hbo_instructions',
        title: i18n.tc('digitalServices.sidebar.items.instructions')
      }
    ]
  },
  {
    name: 'DEEZER',
    title: i18n.tc('digitalServices.sidebar.items.deezer'),
    submenu: [
      {
        name: 'deezer_instructions',
        title: i18n.tc('digitalServices.sidebar.items.instructions')
      }
    ]
  },
  {
    name: 'MOVE',
    title: i18n.tc('digitalServices.sidebar.items.move'),
    submenu: [
      {
        name: 'move_instructions',
        title: i18n.tc('digitalServices.sidebar.items.instructions')
      }
    ]
  },
  {
    name: 'ARENA',
    title: i18n.tc('digitalServices.sidebar.items.arenaCloud'),
    submenu: [
      {
        name: 'arena_cloud_instructions',
        title: i18n.tc('digitalServices.sidebar.items.instructions')
      }
    ]
  },
  {
    name: 'APOLLON',
    title: i18n.tc('digitalServices.sidebar.items.apollon'),
    submenu: [
      {
        name: 'apollon_instructions',
        title: i18n.tc('digitalServices.sidebar.items.instructions')
      }
    ]
  }
]
